export { default } from './DeprecatedTooltip';
